import { useScope } from "~/hooks/useScope";
import { OrganizationPoliciesAddPage } from "~/pages/organization/policies-add/OrganizationPoliciesAddPage";

export function OrganizationPoliciesAddEntryPage() {
  const { organizationScope } = useScope();
  return organizationScope ? (
    <OrganizationPoliciesAddPage scope={organizationScope} />
  ) : undefined;
}
